var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#FFCC91",
    fillOpacity: 0.16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2573_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 26.3333C25.1269 26.3333 25.5 25.9602 25.5 25.5C25.5 25.0398 25.1269 24.6667 24.6667 24.6667C24.2064 24.6667 23.8333 25.0398 23.8333 25.5C23.8333 25.9602 24.2064 26.3333 24.6667 26.3333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 26.3333C15.9602 26.3333 16.3333 25.9602 16.3333 25.5C16.3333 25.0398 15.9602 24.6667 15.5 24.6667C15.0398 24.6667 14.6667 25.0398 14.6667 25.5C14.6667 25.9602 15.0398 26.3333 15.5 26.3333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 8.83333H12.1667L14.4 19.9917C14.4762 20.3753 14.6849 20.72 14.9896 20.9652C15.2943 21.2105 15.6756 21.3408 16.0667 21.3333H24.1667C24.5577 21.3408 24.939 21.2105 25.2437 20.9652C25.5484 20.72 25.7571 20.3753 25.8333 19.9917L27.1667 13H13",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2573_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.43e66d6e5ec0b5911ae2609cdb2aa85d.svg";
export { ForwardRef as ReactComponent };